import { Badge, Banner, BlockStack, Button, Card, Divider, Grid, Icon, InlineStack, Link, Spinner, Text } from '@shopify/polaris';
import { ClockMinor, OrdersMinor, ProductsMajor } from '@shopify/polaris-icons';
import inactive from '../../../../Asests/Images/inactive.png';
import active from '../../../../Asests/Images/active.png';
import error from '../../../../Asests/Images/error.png';
import incomplete from '../../../../Asests/Images/incomplete.png';
import notlisted from '../../../../Asests/Images/not-listed.png';
import React, { useEffect, useMemo, useState } from 'react';
import { DI, DIProps } from '../../../../Core';
import { appBridgeRouting } from '../../Panel/index';
import { gridFilters } from '../../Listing Grid/Utilities/Constants';
import { useTranslation } from "react-i18next";
import { CheckProductLinkedIcon } from '../../../../Asests/svgIcon/icon';
import { timeSinceLastUpdate, usePreciseTimeAgo } from '../Utils/HelperFunc';

interface props extends DIProps {
    totalProductCount: string
    duplicateSkuFlag: number
}

const Products = (props: props) => {
    const { t } = useTranslation();
    const data = [
        { id: "product_status", heading: t('Product Status'), button: t('Manage Listing'), descreption: t('Stay up-to-date with the status of all the product(s) that are enabled in your Shopify store for Amazon by Cedcommerce app to sync on Amazon Marketplace here.') },
        { id: 'product_linking', heading: t('Product Linking'), button: t('Manage Linking'), descreption: t('Discover which products have been successfully synced or have failed synching due to a mismatch of data on Amazon and Shopify.') },
    ]
    const { totalProductCount, duplicateSkuFlag } = props;
    const [loader, setLoader] = useState<boolean>(true);

    const [productStatus, setProductStatus] = useState([
        { id: 'inactive', icon: inactive, status: 'Inactive', items: '0' },
        { id: 'not_listed', icon: notlisted, status: 'Not Listed', items: '0' },
        { id: 'active', icon: active, status: 'Active', items: '0' },
        // { id: 'Ready To Upload', icon: notlisted, status: 'Ready to upload', items: '0' },
        { id: 'Uploaded', icon: active, status: 'Uploaded', items: '0' },
        { id: 'incomplete', icon: incomplete, status: 'Incomplete', items: '0' },
        { id: 'error', icon: error, status: 'Error', items: '0' },
    ])
    const [productLinkingStatus, setProductLinkingStatus] = useState([
        { id: 'close_matched', color: 'rgb(255 214 164)', status: 'Close Match', items: '0' },
        { id: 'not_linked', color: 'rgb(213 235 255)', status: 'Linking Required', items: '0' },
        { id: 'linked', color: 'rgb(180 254 210)', status: 'Linked', items: '0' }
    ])

    useEffect(() => {
        getStatusWiseFilterCount();
        getMatchStatusCount();
    }, [])


    // const getStatusWiseFilterCount = () => {
    //     let temp: any = JSON.parse(JSON.stringify([...productStatus]));
    //     let AllstatusFilter: any = {}
    //     let TempDataForMatch: any = {
    //         'Not Listed: Offer': 0,
    //         'Not Listed': 0,
    //         // 'Ready To Upload': 0,
    //         Uploaded: 0,
    //         Inactive: 0,
    //         Active: 0,
    //         Incomplete: 0,
    //         null: 0,
    //     };
    //     props.di.GET("connector/product/getStatusWiseCount", { useRefine: true, productOnly: true, getErrorCount: true })
    //         .then((data: any) => {
    //             if (data?.success) {
    //                 console.log(data?.data?.facet?.value?.buckets,"bjvjkfbvkjfv kjfd")
    //                 if (data?.data?.length > 0) {
    //                     data?.data?.forEach((status: { [name: string]: any }) => {
    //                         Object.keys(TempDataForMatch).forEach((element) => {
    //                             if (status['_id'] == null)
    //                                 AllstatusFilter['null'] = status['total']
    //                             else if (element == status['_id'])
    //                                 AllstatusFilter[status['_id']] = status['total'];
    //                             else if (!AllstatusFilter[element])
    //                                 AllstatusFilter[element] = 0;
    //                         });
    //                     })
    //                 }
    //                 else AllstatusFilter = { ...TempDataForMatch };
    //                 AllstatusFilter['Not Listed'] =
    //                     (AllstatusFilter?.['Not Listed'] && AllstatusFilter?.['Not Listed: Offer']) ?
    //                         AllstatusFilter['null'] + AllstatusFilter['Not Listed'] + AllstatusFilter['Not Listed: Offer']
    //                         : AllstatusFilter?.['Not Listed'] ?
    //                             AllstatusFilter?.['Not Listed'] + AllstatusFilter['null']
    //                             : AllstatusFilter?.['Not Listed: Offer'] ?
    //                                 AllstatusFilter?.['Not Listed: Offer'] + AllstatusFilter['null']
    //                                 : AllstatusFilter['null'];

    //                 temp?.forEach((status: any) => {
    //                     if (status?.id === "error") {
    //                         if (data?.error_count?.success) {
    //                             status.items = data?.error_count?.count?.count || 0;
    //                         }
    //                         else props.error(t(data?.error_count?.message))
    //                     }
    //                     else status.items = AllstatusFilter[status?.status] || 0
    //                 });
    //                 setProductStatus([...temp]);
    //             }
    //             else props?.error(t(data.message));
    //             setLoader(false);
    //         });
    // }


    const [statusWiseCountCacheAt, setstatusWiseCountCacheAt] = useState("")

    const getStatusWiseFilterCount = (refresh?: boolean) => {
        setLoader(true);
        const defaultCounts: Record<string, number> = {
            'Not Listed: Offer': 0,
            'Not Listed': 0,
            Uploaded: 0,
            Inactive: 0,
            Active: 0,
            Incomplete: 0,
            null: 0,
        };

        let allStatusCount: Record<string, number> = { ...defaultCounts };
        let tempStatus = JSON.parse(JSON.stringify([...productStatus]));
        let totalCount = 0;

        let payload: any = {
            "useCache": true,

            useRefine: false,
            productOnly: true,
            getErrorCount: true
        }

        if (refresh) {
            payload["refresh"] = true;
        }

        props.di.GET("connector/product/getStatusWiseCount", payload)
            .then((data: any) => {
                if (!data?.success) {
                    props?.error(t(data.message));
                    setLoader(false);
                    return;
                }

                if (data?.cached_at) {
                    setstatusWiseCountCacheAt(data?.cached_at)
                }

                const buckets = data?.data?.facet?.value?.buckets || [];
                totalCount = data?.data?.totalCount ?? 0;

                console.log(data,"xfcgvhbjnkmgvhbjnmk")

                for (const bucket of buckets) {
                    const id = bucket?._id ?? "null";
                    const count = bucket?.count ?? 0;
                    if (id in allStatusCount) {
                        allStatusCount[id] = count;
                    }
                }


                // Calculate 'Not Listed'
                const notListedCount =
                    (allStatusCount['Not Listed'] ?? 0) +
                    (allStatusCount['Not Listed: Offer'] ?? 0) +
                    (allStatusCount['null'] ?? 0);

                // Exclude uploaded/active/inactive/incomplete from total
                ['Uploaded', 'Active', 'Inactive', 'Incomplete', 'Not Listed: Offer'].forEach(status => {
                    totalCount -= allStatusCount[status] ?? 0;
                });



                allStatusCount['Not Listed'] = notListedCount + totalCount;

                // Update items count in productStatus
                tempStatus.forEach((status: any) => {
                    if (status?.id === "error") {
                        if (data?.error_count?.count?.count >= 0) {
                            status.items = data?.error_count?.count?.count || 0;
                        }
                    } else {
                        status.items = allStatusCount[status?.status] || 0;
                    }
                });

                setProductStatus([...tempStatus]);
                setLoader(false);
            })
            .catch((error: any) => {
                props?.error(t("Failed to load status counts"));
                console.error(error);
                setLoader(false);
            });
    };


    const getMatchStatusCount = () => {
        let temp: any = JSON.parse(JSON.stringify([...productLinkingStatus]));
        let DataToSend: any = {
            "target": {
                "marketplace": props.redux.current.target.marketplace,
                "shopId": props.redux.current.target?.['_id']
            },
            "source": {
                "marketplace": props.redux.current.source.marketplace,
                "shopId": props.redux.current.source?.['_id']
            },
        }
        props.di.POST("amazon/product/getMatchStatusCount", DataToSend).then((data: any) => {
            if (data?.success) {
                Object.keys(data?.data)?.forEach((key) => {
                    temp?.forEach((status: any) => status.items = data?.data?.[status?.id] || 0)
                })
                setProductLinkingStatus([...temp])
            }
            else props.error(t(data.message));
            setLoader(false);
        })
    }

    const pushToGrid = (status: string, duplicate_sku_filter?: boolean) => {
        props.di.globalState.removeLocalStorage(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`);
        let filters = JSON.parse(JSON.stringify({ ...gridFilters }))

        let prodStatusFilter = filters?.['Product Status'];
        let activityFilter = filters?.['Activity'];

        if (!duplicate_sku_filter) {
            if (status == 'Error') {
                activityFilter['textValue'] = 'error';
                activityFilter['change'] = true;
            }
            else if (status == "Not Listed") {
                prodStatusFilter['textValue'] = status;
                prodStatusFilter['value'] = 'cif_amazon_multi_inactive'
                prodStatusFilter['change'] = true;
            }
            else if (status == "Uploaded") {
                prodStatusFilter['textValue'] = status;
                prodStatusFilter['value'] = 'cif_amazon_multi_uploaded'
                prodStatusFilter['change'] = true;
            }
            else {
                prodStatusFilter['change'] = true;
                prodStatusFilter['textValue'] = status;
                prodStatusFilter['value'] = 'items.status';
            }

            switch (status) {
                case 'Inactive':
                    props.di.globalState.set("tabs", "3", true);
                    break;
                case 'Not Listed':
                    props.di.globalState.set("tabs", "1", true);
                    break;
                case 'Not Listed: Offer':
                    props.di.globalState.set("tabs", "0", true);
                    break;
                case 'Active':
                    props.di.globalState.set("tabs", "5", true);
                    break;
                case 'Incomplete':
                    props.di.globalState.set("tabs", "4", true);
                    break;
                // case 'Ready To Upload':
                //     props.di.globalState.set("tabs", "2", true);
                //     break;
            }
        }
        else {
            let duplicateFilter = filters?.['Duplicate SKU'];
            duplicateFilter['textValue'] = true;
            duplicateFilter['change'] = true;
        }

        props.di.globalState.set(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`, JSON.stringify(filters), true);
        appBridgeRouting("product", props)
    }
    const timeAgo = useMemo(() => timeSinceLastUpdate(statusWiseCountCacheAt), [statusWiseCountCacheAt]);
    // const timeAgo = usePreciseTimeAgo(statusWiseCountCacheAt);
    return (
        <Card roundedAbove='sm'>
            <BlockStack gap="200">
                <BlockStack gap="200">
                    <InlineStack gap="200" align="space-between" blockAlign='center'>
                        <InlineStack gap="300" blockAlign='center'>
                            <Text variant="headingMd" as="h6">{t("Products")}</Text>
                            {loader ? <Spinner accessibilityLabel="Small spinner example" size="small" /> : <Badge size='large' icon={ProductsMajor} tone="attention">{`${t("Total Products")}: ${totalProductCount}`}</Badge>}
                        </InlineStack>
                        <InlineStack gap={'150'}>
                            <Text as='p' tone='subdued'>
                                <InlineStack>
                                    <Icon source={ClockMinor}></Icon>
                                    <Text as='p'>Last updated: {timeAgo}</Text>
                                </InlineStack>
                            </Text>
                            <Button onClick={() => getStatusWiseFilterCount(true)}>{t("Refresh Now")}</Button>
                        </InlineStack>
                    </InlineStack>
                    <Divider></Divider>
                </BlockStack>
                <BlockStack gap="200">
                    {
                        duplicateSkuFlag &&
                        <Banner
                            tone='warning'
                            action={{
                                content: t('Click to view products'),
                                onAction: () => pushToGrid('', true)
                            }}
                        >
                            {t("A few duplicate products (SKUs) are identified on Shopify. We've updated their SKUs with a unique value in our app.")}
                        </Banner>
                    }
                    <BlockStack gap="300">
                        {data.map((item, index) => {

                            return (<div key={item.id}>
                                <BlockStack gap="300">
                                    <BlockStack gap="300">
                                        <BlockStack gap="100">
                                            <InlineStack gap="200" align="space-between">
                                                <Text variant="headingMd" as="h6" fontWeight='medium'>{item.heading}</Text>
                                                <Button
                                                    variant="plain"
                                                    onClick={() => {
                                                        if (item.id === 'product_status') {
                                                            props.di.globalState.removeLocalStorage('tabs');
                                                            appBridgeRouting('product', props)
                                                        }
                                                        else appBridgeRouting('productlinkings?tab=1', props)
                                                    }}
                                                >
                                                    {item.button}
                                                </Button>

                                            </InlineStack>
                                            <Text variant="headingMd" as="h6" fontWeight='regular' tone="subdued">{item.descreption}</Text>
                                        </BlockStack>
                                        <Card>
                                            <Grid columns={item.id === 'product_status' ? { xs: 2, sm: 2, md: 4, lg: 4, xl: 4 } : { xs: 2, sm: 2, md: 3, lg: 4, xl: 4 }}>
                                                {
                                                    item.id === 'product_status' ?
                                                        productStatus.map((item, idx) => {
                                                            return (
                                                                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} key={item.id}>
                                                                    <InlineStack blockAlign='start' gap="100" wrap={false}>
                                                                        <img src={item.icon} />
                                                                        <BlockStack gap="200">
                                                                            <Text as="p">{t(item.status)}</Text>
                                                                            {
                                                                                loader ?
                                                                                    <Spinner accessibilityLabel="Small spinner example" size="small" />
                                                                                    :
                                                                                    <Link removeUnderline onClick={() => pushToGrid(item.status)}>{item.items}</Link>
                                                                            }
                                                                        </BlockStack>
                                                                    </InlineStack>
                                                                </Grid.Cell>
                                                            )
                                                        })
                                                        :
                                                        productLinkingStatus.map((item, idx) => (
                                                            <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} key={item.id + "_" + idx}>
                                                                <InlineStack blockAlign='start' gap="100">
                                                                    <CheckProductLinkedIcon color={item.color} />
                                                                    <BlockStack gap="200">
                                                                        <Text as="p">{t(item.status)}</Text>
                                                                        {
                                                                            loader ?
                                                                                <Spinner accessibilityLabel="Small spinner example" size="small" />
                                                                                :
                                                                                <Link
                                                                                    removeUnderline
                                                                                    onClick={() => {
                                                                                        item.id === 'linked' ?
                                                                                            appBridgeRouting('productlinkings?tab=2', props)
                                                                                            :
                                                                                            item.id === 'close_matched' ?
                                                                                                appBridgeRouting('productlinkings?tab=0', props)
                                                                                                :
                                                                                                appBridgeRouting('productlinkings?tab=1', props)
                                                                                    }}>
                                                                                    {item.items}
                                                                                </Link>
                                                                        }
                                                                    </BlockStack>
                                                                </InlineStack>
                                                            </Grid.Cell>
                                                        ))
                                                }
                                            </Grid>
                                        </Card>
                                    </BlockStack>
                                    {index < data.length - 1 && <Divider />}
                                </BlockStack>
                            </div>)
                        })}
                    </BlockStack>
                </BlockStack>
            </BlockStack>
        </Card>
    );
}

export default DI(Products);